import { Smartphone, CalendarClock, Scale } from "lucide-react";
import { t } from "@/lib/i18n";
import Reveal from "@/components/Reveal";

const STEPS = [
  { icon: Smartphone, title: "Sign up & add your address", body: "Open app.kindsaver.com, sign in with your phone number and save your home or shop address." },
  { icon: CalendarClock, title: "Choose items & a time slot", body: "Tell us roughly what you have — paper, plastic, metal, e-waste — and pick a slot that suits you." },
  { icon: Scale, title: "Kabadiwala weighs & pays", body: "A local kabadiwala comes to your door, weighs everything in front of you and pays as per the agreed rate." },
];

export default function HowItWorks() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24" data-testid="how-it-works-section">
      <Reveal className="max-w-2xl">
        <div className="text-xs font-bold tracking-[0.2em] uppercase text-[var(--leaf)]">{t("How it works")}</div>
        <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">{t("Three simple steps. No haggling, no hunting.")}</h2>
      </Reveal>
      <div className="relative mt-14 grid md:grid-cols-3 gap-6 md:gap-8">
        <svg className="hidden md:block absolute top-10 left-[12%] right-[12%] w-[76%] h-6 pointer-events-none" viewBox="0 0 100 6" preserveAspectRatio="none" aria-hidden="true">
          <path d="M0 3 Q 25 0 50 3 T 100 3" fill="none" stroke="var(--marigold)" strokeWidth="0.5" strokeDasharray="1.5 1.5" />
        </svg>
        {STEPS.map(({ icon: Icon, title, body }, i) => (
          <Reveal key={t(title)} delay={i * 120} className="relative" data-testid={`how-step-${i + 1}`}>
            <div className="w-20 h-20 rounded-[26px] bg-[var(--leaf)] text-white flex items-center justify-center relative z-10 shadow-[0_18px_30px_-16px_rgba(46,125,50,.8)]">
              <Icon size={30} />
              <span className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-[var(--marigold)] text-[var(--ink)] text-sm font-extrabold flex items-center justify-center border-4 border-[var(--paper)]">{i + 1}</span>
            </div>
            <h3 className="mt-7 text-xl sm:text-2xl font-bold">{t(title)}</h3>
            <p className="mt-3 text-[var(--ink-soft)] leading-relaxed">{t(body)}</p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
